import React from "react";
import TrailTable from "components/common/TrailTable/TrailTable";

interface Props {
  entityId: string | number;
}

const PaymentsTrailTab: React.FC<Props> = ({ entityId }) => {
  return <TrailTable entityType="footerPayments" entityId={Number(entityId)} />;
};

export default PaymentsTrailTab;
